import { useCurrentCategoryValue, useServices } from '../../../context';
import { setStoreNameData } from '../context/storeNameAtoms';
import { normalizeProducts } from '../utils';

export function useStoreSuggestions() {
  const selectedCategory = useCurrentCategoryValue();
  const { chatServiceDs: chatService } = useServices();

  async function getStoreNameSuggestions() {
    if (!selectedCategory) {
      return;
    }

    try {
      setStoreNameData({ isLoadingSuggestions: true });
      const result = await chatService.suggestStoreName(selectedCategory, normalizeProducts(selectedCategory));
      setStoreNameData({
        suggestions: result || [],
        isLoadingSuggestions: false,
      });
    } catch (error) {
      console.error('Failed to get store name suggestions:', error);
      setStoreNameData({
        suggestions: [],
        isLoadingSuggestions: false,
      });
    }
  }

  return {
    getStoreNameSuggestions,
  };
}
